import React from "react";
import { Input, Radio, Space, Typography } from "antd";
import {
  APPOINTMENT_REMOVAL_NOTE_MAX_LENGTH,
  APPOINTMENT_REMOVAL_REASON_OTHER,
  APPOINTMENT_REMOVAL_REASONS,
  type AppointmentRemovalPayload,
} from "@/constants/appointmentRemovalReasons";

interface Props {
  value: AppointmentRemovalPayload;
  onChange: (value: AppointmentRemovalPayload) => void;
  /** Focus the note box as soon as "Other" is picked. */
  autoFocusNote?: boolean;
}

/**
 * Fixed-list reason picker used by every gesture that removes a scheduled
 * appointment (EDB unassign / remove last tech / drag to Unscheduled, and the
 * conflict bell's "release" action). Controlled: the parent decides when the
 * selection is complete via isRemovalPayloadComplete().
 */
const AppointmentRemovalReasonPicker: React.FC<Props> = ({ value, onChange, autoFocusNote = true }) => {
  const isOther = value.removal_reason === APPOINTMENT_REMOVAL_REASON_OTHER;

  return (
    <div>
      <Typography.Paragraph style={{ marginBottom: 6, fontWeight: 500 }}>Why is the appointment being removed?</Typography.Paragraph>
      <Radio.Group
        value={value.removal_reason}
        onChange={(e) => onChange({ ...value, removal_reason: e.target.value })}
        style={{ width: "100%" }}
      >
        <Space direction="vertical" size={2}>
          {APPOINTMENT_REMOVAL_REASONS.map((r) => (
            <Radio key={r.value} value={r.value}>
              {r.label}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
      <Input.TextArea
        value={value.removal_note ?? ""}
        onChange={(e) => onChange({ ...value, removal_note: e.target.value })}
        rows={2}
        maxLength={APPOINTMENT_REMOVAL_NOTE_MAX_LENGTH}
        showCount={isOther}
        autoFocus={isOther && autoFocusNote}
        placeholder={isOther ? "Describe the reason (required for Other)" : "Additional details (optional)"}
        style={{ marginTop: 10 }}
      />
    </div>
  );
};

export default AppointmentRemovalReasonPicker;
